import React, { createContext, useState, useCallback, useContext } from "react";

const SidebarContext = createContext(undefined);

export const SidebarProvider = ({ children }) => {
  const [isAdminSettingsPage, setIsAdminSettingsPage] = useState(false);
  const [isExportDomainPage, setIsExportDomainPage] = useState(false);
  const [resetRequested, setResetRequested] = useState(false);
  const [showDraftModals, setShowDraftModals] = useState(false);
  const [attachments, setAttachments] = useState([]);

  // New state for sidebar expansion
  const [isExpanded, setIsExpanded] = useState(true);

  const triggerGraphReset = useCallback(() => {
    setResetRequested(true);
  }, []);

  const completeReset = useCallback(() => {
    setResetRequested(false);
  }, []);

  const value = {
    isAdminSettingsPage,
    setIsAdminSettingsPage,
    isExportDomainPage,
    setIsExportDomainPage,
    resetRequested,
    triggerGraphReset,
    completeReset,
    showDraftModals,
    setShowDraftModals,
    attachments,
    setAttachments,
    isExpanded,
    setIsExpanded, // Add the setter
  };

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

export { SidebarContext };
